import React from "react";
import Popover, { Heading, Details, SearchArea } from "./Popover";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

const category = [
  "Crawler Excavators",
  "Wheel Excavators",
  "Dump trucks",
  "Backhoe Loaders",
  "Dozers",
  "Wheel loaders",
  "Generators",
  "Forklifts",
  "Scissor lifts",
  "Asphalt pavers",
  "Compressors",
  "Motor graders",
  "Cranes",
];

const make = [
  "Tractor units",
  "Concrete mixer trucks",
  " Concrete pump trucks",
  "Tipper trucks",
  "Trailers",
  "Semi Trailers",
  "Closed box trucks",
  " Vans",
];

function Auction() {
  return (
    <Popover label="Auction">
      <Heading>Explore Machinery for Auction</Heading>
      <Container
        disableGutters
        sx={{
          marginTop: "28px",
          display: "flex",
          columnGap: "50px",
        }}
      >
        <Details label="Category" content={category} />
        <Details label="Make" content={make} />
        <Box
          sx={{
            width: "1px",
            minHeight: "100%",
            backgroundColor: "#BFBFBF",
          }}
        ></Box>
        <SearchArea />
      </Container>
    </Popover>
  );
}

export default Auction;
